/**
 * Textarea — themeable multi-line text field (Claude Design `.textarea`):
 * shares the Input surface/focus styling, resizes vertically, min-height 76px.
 */
import { forwardRef, type TextareaHTMLAttributes } from 'react';

import { cn } from './cn.js';
import { inputClasses } from './Input.js';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => (
    <textarea
      ref={ref}
      className={cn(inputClasses, 'min-h-[76px] resize-y py-2', className)}
      {...props}
    />
  ),
);
Textarea.displayName = 'Textarea';
